import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/authActions';

import * as ROUTES from '../../constants/routes';

const SignedInLinks = (props) => {

    console.log("PROPS: " + props);

    const { auth } = props;

    return (
        <React.Fragment>        
            <ul className="navbar-nav mr-auto">
                <li className="nav-item"><NavLink className="nav-link" to={ROUTES.HOME}>Home</NavLink></li>
                </ul>     
            <ul className="navbar-nav ">
                <li className="nav-item"><a className="nav-link" onClick={props.signOut}>Log Out</a>
                </li>
                <li><NavLink to={'/users/' + auth.uid} className="btn btn-info rounded-circle" style={buttonStyle}>
                        {props.profile.initials} 
                    </NavLink>
                </li>
            </ul>
        </React.Fragment>
    )
};


const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => dispatch(signOut())
    }
}

const buttonStyle = {
    marginLeft: "20px"
    // width: "30px",
    // height: "30px",
    // padding: "6px 0px",
    // borderRadius: "15px",
    // textAlign: "center",
    // fontSize: "12px",
    // lineHeight: "1.42857"
}

export default connect(null, mapDispatchToProps)(SignedInLinks);